<template>
    <div class="page pageRes">
        <div class="map-main">
            <el-form class="page-query" :model="formSearch" :inline="true" size="mini">
                <el-form-item :label="$t('res.knowName')">
                    <el-input v-model="formSearch.title" :placeholder="$t('tip.name')"
                            @keyup.enter.native="getKnowData(1)" clearable></el-input>
                </el-form-item>
                <select-multiple :nameArrays="selectNames"
                        v-on:getKnowledgeTypeVal="getKnowledgeTypeVal">
                </select-multiple>
                <el-form-item :label="$t('res.uploader')">
                    <el-input v-model="formSearch.creatorName" :placeholder="$t('tip.uploader')" clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('res.knowTag')">
                    <el-input v-model="formSearch.tag" :placeholder="$t('tip.knowTagTip')" clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('res.uploadTime')">
                    <el-date-picker
                        v-model="formSearch.afterDate"
                        type="date"
                        :placeholder="$t('tip.startTime')"
                        :picker-options="pickerOptions1"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <span> {{$t('c.to')}} </span>
                    <el-date-picker
                        v-model="formSearch.beforeDate"
                        type="date"
                        :placeholder="$t('tip.endTime')"
                        :picker-options="pickerOptions2"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  @click="getKnowData(1)" round>{{$t('c.query')}}</el-button>
                </el-form-item>
            </el-form>
            <div class="page-table">
                <div class="page-operate">
                    <el-button-group>
                        <el-tooltip class="item" effect="dark" :content="$t('res.checkAll')" placement="top-start"
                                    :hide-after="1000">
                            <el-button size="small" @click="handleCheckAllChange"
                                    :disabled="listData.length==0?true:false"
                                    :class="[checkAll ? 'btn-active': 'btn-not-active']">
                                <i class="nucfont inuc-checkall"></i>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" :content="$t('res.addKnowledge')" placement="top-start"
                                    :hide-after="1000">
                            <el-button size="small" @click="addKnowledge">
                                <i class="nucfont inuc-add"></i>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip v-show="isDeleteShow" class="item" effect="dark" :content="$t('c.delete')"
                                    placement="top-start"
                                    :hide-after="1000">
                            <el-button size="small" @click="deleteKnow">
                                <i class="nucfont inuc-delete"></i>
                            </el-button>
                        </el-tooltip>
                    </el-button-group>
                    <el-button-group style="margin-left: 10px;">
                        <el-tooltip class="item" effect="dark" content="按浏览量" placement="top-start" :hide-after="1000">
                            <el-button size="small" @click="orderChange(1)" :class="[this.sortName=='browseCount' && this.order=='Asc' ? 'btn-active': 'btn-not-active']">
                                <i class="nucfont inuc-compose-times"></i>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="按点赞量" placement="top-start"
                                    :hide-after="1000">
                            <el-button size="small" @click="orderChange(2)" :class="[this.sortName=='likeCount' && this.order=='Asc' ? 'btn-active': 'btn-not-active']">
                                <i class="nucfont inuc-right-rate"></i>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" :content="$t('topic.default')" placement="top-start"
                                    :hide-after="1000">
                            <el-button size="small" @click="orderChange(3)" :class="[this.sortName=='' && this.order=='Asc' ? 'btn-active': 'btn-not-active']">
                                <i class="nucfont inuc-default-sort"></i>
                            </el-button>
                        </el-tooltip>
                    </el-button-group>

                </div>

                <div class="map-list-box">
                    <div class="map-list map-list-table" id="file-list">
                            <ul class="map-table-tile">
                                <li class="info" :title="$t('res.knowName')">{{$t('res.knowName')}}</li><li class="type" :title="$t('res.knowType')">{{$t('res.knowType')}}</li><li class="count" :title="$t('res.pageViews')">{{$t('res.pageViews')}}</li><li class="count" :title="$t('res.likes')">{{$t('res.likes')}}</li><li class="count" :title="$t('res.uploader')">{{$t('res.uploader')}}</li><li class="type" :title="$t('res.uploadTime')">{{$t('res.uploadTime')}}</li><li class="count" :title="$t('c.operation')">{{$t('c.operation')}}</li>
                            </ul>
                            <el-checkbox-group v-model="selectFiles" @change="selectFileChange"
                                            style="overflow-y: auto;height: 95%">
                                <transition-group tag="ul" class="images clearfix"
                                                v-viewer="{movable: true}">

                                    <li class="map-table-item" v-for="item in listData" :key="item.id">
                                        <div class="info" v-if="item.resourceType==21"
                                            @click="openFile(item.resource, $event)">
                                            <el-checkbox :label="item.id">{{ }}</el-checkbox>
                                            <span class="folder"></span>
                                            <span class="map-item-name" :title="item.name">{{itemName(item.name)}}</span>
                                        </div>
                                        <div class="info" v-if="item.resourceType==12"
                                            @click="openFile(item.resource, $event)">
                                            <el-checkbox :label="item.id">{{ }}</el-checkbox>
                                            <img class="map-item-img" :src="item.resource.thumbnail" :alt="item.name">
                                            <span class="map-item-name" :title="item.name">{{itemName(item.name)}}</span>
                                        </div>
                                        <div class="info" v-if="item.resourceType==10"
                                            @click="openFile(item.resource, $event)">
                                            <el-checkbox :label="item.id">{{ }}</el-checkbox>
                                            <div class="video"></div>
                                            <span class="map-item-name" :title="item.name">{{itemName(item.name)}}</span>
                                        </div>
                                        <div class="info" v-if="item.resourceType==11"
                                            @click="openFile(item.resource, $event)">
                                            <el-checkbox :label="item.id">{{ }}</el-checkbox>
                                            <div class="audio"></div>
                                            <span class="map-item-name" :title="item.name">{{itemName(item.name)}}</span>
                                        </div>
                                        <div class="info" v-if="item.resourceType==8"
                                            @click="openFile(item.resource, $event)">
                                            <el-checkbox :label="item.id">{{ }}</el-checkbox>
                                            <a>
                                                <div class="document-excel"
                                                    v-if="item.extension=='.xls'||item.extension=='.xlsx'"></div>
                                                <div class="document-pdf" v-else-if="item.extension=='.pdf'"></div>
                                                <div class="document-ppt"
                                                    v-else-if="item.extension=='.ppt'||item.extension=='.pptx'"></div>
                                                <div class="document-txt" v-else-if="item.extension=='.txt'"></div>
                                                <div class="document-word"
                                                    v-else-if="item.extension=='.doc'||item.extension=='.docx'"></div>
                                                <div class="document-undefined" v-else></div>
                                                <span class="map-item-name" :title="item.name">{{itemName(item.name)}}</span>
                                            </a>
                                        </div>
                                        <div class="type">
                                            {{item.categoryName}}
                                        </div>
                                        <div class="count">
                                            {{item.browseCount}}
                                        </div>
                                        <div class="count">
                                            {{item.likeCount}}
                                        </div>
                                        <div class="count">
                                            {{item.resource.creatorName}}
                                        </div>
                                        <div class="type">
                                            {{item.createTime.substring(0,10)}}
                                        </div>
                                        <div class="count">
                                            <span :title="$t('c.view')" @click="viewKnowledge(item)" class="nucfont inuc-preview view"></span>
                                            <span v-if="userInfo.userID==item.creator" :title="$t('c.edit')" @click="editKnowledge(item)" class="nucfont inuc-edit view"></span>
                                        </div>
                                    </li>
                                </transition-group>
                            </el-checkbox-group>
                            <span v-show="!pagTotal" class="emptyBox">{{$t('c.noData')}}</span>
                        <!-- </template> -->
                    </div>
                </div>

                <div class="pagination-bar">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        layout="total, prev, pager, next, jumper"
                        :total="pagTotal"
                        :page-size="pageSize">
                    </el-pagination>
                </div>
            </div>
        </div>
        <add-knowledge
            :knowledgeDialog = "dialog.knowledgeDialog"
            :knowledgetID = "dialog.knowledgeID"
            :knowData = "dialog.knowData"
            :dialogType = "dialogType"
            @onDialogClosed="dialog.knowledgeDialog = false"
            @addSaveOver = "saveKnowOver"
            ></add-knowledge>


        <transition
            enter-active-class="animated zoomInRight"
            leave-active-class="animated zoomOutUp"
        >
            <sub-page class="mapDetailPage" :title="subPage.title" :closeFn="closeFile" v-if="subPage.show">
                <div class="container">
                    <iframe v-if="mediaType === 8" class="doc" :src="sectionDocSrc" frameborder="0"></iframe>

                    <div class="player" v-if="mediaType === 10">
                        <video-player class="video-player vjs-custom-skin"
                            ref="videoPlayer"
                            :playsinline="true"
                            :options="playerOptions"
                            @play="onPlayerPlay($event)"
                            @pause="onPlayerPause($event)"
                        >
                        </video-player>
                    </div>
                    <div class="player" v-if="mediaType === 11">
                        <div class="video-player vjs-custom-skin">
                            <div id="vjs_video_4669" class="video-js vjs_video_4669-dimensions vjs-fluid vjs-controls-enabled vjs-workinghover vjs-v7 vjs-has-started" :class="isPlaying?'vjs-playing':'vjs-paused'"
                                lang="zh-cn" role="region" aria-label="音频播放器">
                                <img class="vjs-tech" id="vjs_video_4669_html5_api" src="../../assets/images/course/audio_bg.png" @click="pause"/>

                                <button class="vjs-big-play-button" type="button" title="播放音频" aria-disabled="false" @click="play">
                                    <span aria-hidden="true" class="vjs-icon-placeholder"></span>
                                    <span class="vjs-control-text" aria-live="polite">播放音频</span>
                                </button>
                                <div class="aplayer-control-bar">
                                    <aplayer style="margin:0" ref="audioPlayer" :music="media" @play="play" @pause="pause"/>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </sub-page>
        </transition>
    </div>
</template>

<script>
    import api from '@/api';
    import {Ticket} from '@/utils';
    import SubPage from '@/components/Subpage';
    import addKnowledge from './Components/AddKnowledge'
    import selectMultiple from '@/components/Selectmultiple';
    import Aplayer from 'vue-aplayer'
    import VideoPlayer from "@/components/VideoPlayer"

    const newMenuData = () => ({id: null})

    export default {
        components: {
            Aplayer,
            VideoPlayer,
            SubPage,
            selectMultiple,addKnowledge
        },
        data() {
            Aplayer.disableVersionBadge = true
            return {
                formSearch: {
                    title: '',
                    categories: [0],
                    tag: '',
                    isOnlyMine:false,
                    creatorName: '',
                    afterDate: '',
                    beforeDate: ''
                },
                userInfo: {},
                selectNames: [{
                    key: "knowledgeType",
                }],
                sortName: '',
                order: '',
                // knowledgeDialog: false,

                isPlaying: false,
                media: null,
                // radio: this.$t('res.fileView'),
                sectionDocSrc: '',
                mediaType: 0,
                checkAll: false,
                isShow: true,
                superiorID: null,
                showCtx: false,
                menuData: newMenuData(),
                playerOptions: {
                    autoplay: false, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: this.$i18n.locale,
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        type: 'application/x-mpegURL',
                        // type: videoUrl.toLowerCase().split('.').splice(-1) == 'mp4'?'video/mp4':'application/x-mpegURL',
                        // src: 'https://vodcdn.alicdn.com/oss/taobao-ugc/e6fb60eae8594f9e812233489bfa2732/1476578718/video.mp4',//你的m3u8地址（必填）
                        //    src: 'videoUrl',
                        src: 'https://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8',
                        withCredentials: false
                    }],
                    // poster: "http://i5.hexun.com/2017-10-30/191428422.jpg", //你的封面地址
                    width: document.documentElement.clientWidth,
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    //controlBar: {
                    //  timeDivider: true,
                    //  durationDisplay: true,
                    //  remainingTimeDisplay: false,
                    //  fullscreenToggle: true  //全屏按钮
                    //}
                    html5: {hls: {withCredentials: false}},
                    //    flash: {swf: '//path/to/videojs.swf'}
                },
                options: [{
                    value: '',
                    label: this.$t('c.all')
                }, {
                    value: 'Picture',
                    label: this.$t('c.image')
                }, {
                    value: 'Document',
                    label: this.$t('c.document')
                }, {
                    value: 'Audio',
                    label: this.$t('c.audio')
                },{
                    value: 'Video',
                    label: this.$t('c.video')
                }],
                value4: '',
                listPath: '',
                isHover: false,
                listData: [],       //左侧的文件数据
                selectFiles: [],    //选择的文件
                formSearch: {
                    name: ''
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },

                pagTotal: 0,
                pageSize: 50,
                currentPage: 1,
                isDeleteShow: false,
                switchStyle: true,
                subPage: {
                    show: false,
                    title: '',
                    data: {}
                },
                subData: {},
                carouselIndex: 0,
                result: false,
                knowledgeID: '',
                dialog:{
                    knowledgeDialog: false,
                    knowData: {},
                },
                dialogType: 1 //1-添加 2-修改 3-查看
            };
        },
        created() {
            if (Ticket.get()) {
                this.userInfo = Ticket.get();
            }
            this.getKnowData()
        },
        computed: {
            player() {
                return this.$refs.videoPlayer.player
            },
            pickerOptions1() {
                let that = this
                return {
                    disabledDate(time) {
                        if (!that.formSearch.beforeDate) return false;
                        return time.getTime() > new Date(that.formSearch.beforeDate).getTime()
                    },
                }
            },
            pickerOptions2() {
                let that = this
                return {
                    disabledDate(time) {
                        if (!that.formSearch.afterDate) return false;
                        return time.getTime() < new Date(that.formSearch.afterDate).getTime()
                    },
                }
            },
        },
        mounted () {

        },
        methods: {
            // 查询知识库列表
            getKnowData(type){
                if(type == 1){
                    this.currentPage = 1
                }
                let queryData = {
                    PageNO: this.currentPage,
                    Limit: this.pageSize,
                    sortName: this.sortName,
                    order: this.order,
                    ...this.formSearch}
                api.queryAsset(queryData).then(res => {
                    this.listData = res.package
                    this.pagTotal = res.total
                })

            },
            // 添加知识
            addKnowledge(){
                this.dialogType = 1
                this.dialog.knowledgeDialog = true
                this.dialog.knowData = null
            },
            editKnowledge(data){
                api.getAssetpDetail(data.id).then(res =>{
                    this.dialogType = 2
                    this.dialog.knowledgeDialog = true
                    this.dialog.knowData = res.package

                })
            },
            viewKnowledge(data){
                api.getAssetpDetail(data.id).then(res =>{
                    this.dialogType = 3
                    this.dialog.knowledgeDialog = true
                    this.dialog.knowData = res.package
                })
            },
            orderChange(orderType){
                switch (orderType){
                    case 1:
                        this.sortName='browseCount';
                        if(this.useOrder=='Desc'){
                            this.useOrder='Asc'
                        }else {
                            this.useOrder='Desc'
                        }
                        this.order=this.useOrder
                        break;
                    case 2:
                        this.sortName='likeCount';
                        if(this.accOrder=='Desc'){
                            this.accOrder='Asc'
                        }else{
                            this.accOrder='Desc'
                        }
                        this.order=this.accOrder
                        break;
                    case 3:
                        this.sortName='';
                        if(this.defaultOrder=='Desc'){
                            this.defaultOrder='Asc'
                        }else{
                            this.defaultOrder='Desc'
                        }
                        this.order=this.defaultOrder
                        break;
                }
                this.getKnowData(1)
            },

            play() {
                this.$nextTick(() => {
                    this.isPlaying = true;
                    this.$refs.audioPlayer.play();
                        })
            },
            pause(){
                this.$nextTick(() => {
                    this.isPlaying = false;
                    this.$refs.audioPlayer.pause();
                        })
            },
            onPlayerPlay(player) {
                // console.log("play");
            },
            onPlayerPause(player) {
                // console.log("pause");
            },
            handleCheckAllChange(val) {
                if (this.checkAll) {
                    this.selectFiles = [];
                    this.checkAll = false
                } else {

                    let newArr = [];
                    this.listData.forEach((element) => {
                        newArr.push(element.id);
                    });
                    this.selectFiles = val ? newArr : [];
                    this.checkAll = true;
                }
                this.isDeleteShow = this.checkAll;
            },
            deleteKnow(){
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    api.deleteAssets({ids: this.selectFiles}).then(res => {
                        this.success(this.$t('m.delSuccess'));
                        this.checkAll = false;
                        this.isDeleteShow = false;
                        this.getKnowData();
                    });
                }).catch(()=>{});
            },

            formQuery() {
                this.currentPage = 1;
                this.getKnowData();
            },
            //搜索赋值
            getKnowledgeTypeVal(data) {
                this.formSearch.categories = data;
            },

            openFile(data, e) {
                if (e.target.className === 'el-checkbox__original' ||
                    e.target.className === 'el-checkbox__inner') return;
                // if (data.status != 2) return;
                this.isShow = true;
                if (data.type == 12) {
                    const viewer = this.$el.querySelector('.images').$viewer;
                    // console.log(this.$el.querySelector('.images').$viewer)
                    let index = viewer.images.findIndex(ele => ele.alt == data.name);
                    viewer.view(index);
                } else if (data.type == 10) {
                    setTimeout(() => {
                        // console.log('dynamic change options', data)
                        // change src
                        // this.playerOptions.sources[0].src = 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm';
                        // change item
                        this.$set(this.playerOptions.sources, 0, {
                            type: data.entity.url.toLowerCase().split('.').splice(-1) == 'mp4' ? 'video/mp4' : 'application/x-mpegURL',
                            src: data.entity.url,
                        })
                        // change array
                        // this.playerOptions.sources = [{
                        //   type: "video/mp4",
                        //   src: 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
                        // }]
                        this.player.muted(false)
                    }, 300)
                    this.mediaType = data.type;
                    this.subPage.show = true;
                    this.subPage.title = data.name;
                } else if (data.type == 8) {

                    this.sectionDocSrc = encodeURI(data.entity.url);
                    this.mediaType = data.type;
                    this.subPage.show = true;
                    this.subPage.title = data.name;
                } else if (data.type == 11) {
                    this.mediaType = data.type;
                    this.subPage.show = true;
                    this.isPlaying = false;
                    this.subPage.title = data.name;
                    this.media = {
                            title: ' ',
                            artist: data.creatorName,
                            src: data.entity.url,
                            pic: require('../../assets/images/course/play_bg.jpg')
                        }
                }

            },
            closeFile() {
                this.subPage.show = false;
            },
            // 页码变化
            handleCurrentChange(val) {
                this.currentPage = val
                this.getKnowData()
            },
            selectFileChange(value) {
                this.isDeleteShow = this.selectFiles.length > 0;
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.listData.length;
            },
            // 添加或修改完毕执行 查询
            saveKnowOver(){
                console.log('执行完毕')
                if(this.dialogType === 1){
                    this.getKnowData(1)
                } else {
                    this.getKnowData()
                }
            },
            itemName(name){
                let item = ''
                item = name.length > 20 ? (name.substring(0,15) + '...') : name
                return item
            },

            success(msg) {
                this.$message({
                    message: msg,
                    type: 'success'
                })
            },
        },
        watch: {}
    }
</script>

<style lang="scss">
    .pageRes {
        .el-card {
            display: flex;
            flex-direction: column;
            height: 100%;
            .el-card__header {
                flex-shrink: 0;
            }
            .el-card__body {
                flex: 1;
                .container, .player, .player > div {
                    height: 100%;
                }
            }
        }
        .vjs-fluid {
            height: 100%;
            padding-top: 0;
        }
    }
</style>


<style lang="scss" scoped>
    @import '../../style/const.scss';

    @include scrollbar();

    .map-main {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        margin-right: 20px;
    }

    .map-list-box {
        position: relative;
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-bottom: 15px;
        border: 1px solid #ddd;
        min-height: 0;

        .map-list {
            padding: 10px;
            flex: 1;
            background-color: #fff;
            overflow-y: auto;
            .emptyBox {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                color: #909399;
            }
        }

        .map-list-outer {
            float: left;
            padding: 8px;
            width: 10%;
        }

    }

    $map-bg: #f1f5fa;
    $map-select-border: #90c3fd;

    .map-item {
        position: relative;
        margin: 0 auto;
        width: 90%;
        border: 1px solid transparent;
        cursor: pointer;


        .map-item-img-wrap {
            @extend .folder;
            background: none;

            .map-item-img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }

        .res-video {
            @extend .folder;
            background: url(../../assets/images/course/video.png) center no-repeat;
            background-size: cover;
        }
        .res-audio {
            @extend .folder;
            background: url(../../assets/images/course/audio.png) center no-repeat;
            background-size: cover;
        }
        .res-document-excel {
            @extend .folder;
            background: url(../../assets/images/document/excel.png) center no-repeat;
            background-size: cover;
        }
        .res-document-pdf {
            @extend .folder;
            background: url(../../assets/images/document/pdf.png) center no-repeat;
            background-size: cover;
        }
        .res-document-ppt {
            @extend .folder;
            background: url(../../assets/images/document/ppt.png) center no-repeat;
            background-size: cover;
        }
        .res-document-txt {
            @extend .folder;
            background: url(../../assets/images/document/txt.png) center no-repeat;
            background-size: cover;
        }
        .res-document-undefined {
            @extend .folder;
            background: url(../../assets/images/document/undefined.png) center no-repeat;
            background-size: cover;
        }
        .res-document-word {
            @extend .folder;
            background: url(../../assets/images/document/word.png) center no-repeat;
            background-size: cover;
        }

        &-name {
            margin: 5px;
            width:70%;
            font-size: 14px;
            line-height: 1.4;
            text-align: center;
            @include no-wrap();
        }

        .el-checkbox {
            position: absolute;
            display: none;
            top: 8px;
            right: 0;
            margin: 0;

            &.is-checked {
                display: block;

                + .checked-bg {
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    border: 1px solid $map-select-border;
                    background-color: $map-bg;
                    border-radius: 5px;
                    z-index: -1;
                }
            }
        }

        &:hover {
            border-color: $map-bg;
            background-color: $map-bg;
            border-radius: 5px;

            .el-checkbox {
                display: block;
            }
        }
    }

    .div-click-disabled {
        cursor: not-allowed;
    }

    .btn-active {
        background-color: #22B9FF;
        color: #fff;
    }

    .btn-not-active {
        background-color: #fff;
        color: #606266;
        border-color: #dcdfe6;
        &:hover {
            color: #22B9FF;
            border-color: #bdeaff;
            background-color: #e9f8ff;
        }
    }
    // 表格形式
    .map-list-table {
        overflow: hidden !important;


        .map-table-tile {
            margin-top: 0;
            height: 36px;
            line-height: 36px;
            display: flex;
            border-bottom: 1px solid #f2f6fd;

            > li {
                font-size: 15px;
                color: #4d4d4d;
                font-weight: bold;
            }

            .info {
                padding-left: 70px;
            }
        }

        .info {
            display: inline-block;
            width: 36%;
        }

        .count {
            display: inline-block;
            width: 10%;
            font-size: 14px;
            text-align: center;
            @include no-wrap;
            .view{
                font-size: 18px;
                color: #a3a4a9;
            }
        }
        .type{
            display: inline-block;
            width: 12%;
            font-size: 14px;
            text-align: center;
            @include no-wrap;
            .view{
                font-size: 18px;
                color: #a3a4a9;
            }
        }
        .map-table-item {
            height: 44px;
            line-height: 44px;
            display: flex;
            // padding-left: 10px;
            border-bottom: 1px solid #f2f6fd;
            cursor: pointer;
            .info{
                padding-left: 10px;
            }

            &:hover {
                background-color: #f6faff;
            }
        }

        .folder {
            display: inline-block;
            width: 26px;
            height: 44px;
            vertical-align: top;
            background: url("../../assets/images/map/folder.png") center no-repeat;
            background-size: contain;

        }
        .video {
            display: inline-block;
            width: 26px;
            height: 44px;
            vertical-align: top;
            background: url("../../assets/images/course/video.png") center no-repeat;
            background-size: contain;

        }
        .audio {
            display: inline-block;
            width: 26px;
            height: 44px;
            vertical-align: top;
            background: url("../../assets/images/course/audio.png") center no-repeat;
            background-size: contain;

        }
        .document-pdf {
            display: inline-block;
            width: 26px;
            height: 44px;
            vertical-align: top;
            background: url("../../assets/images/document/pdf.png") center no-repeat;
            background-size: contain;

        }
        .document-ppt {
            display: inline-block;
            width: 26px;
            height: 44px;
            vertical-align: top;
            background: url("../../assets/images/document/ppt.png") center no-repeat;
            background-size: contain;

        }
        .document-word {
            display: inline-block;
            width: 26px;
            height: 44px;
            vertical-align: top;
            background: url("../../assets/images/document/word.png") center no-repeat;
            background-size: contain;

        }
        .document-excel {
            display: inline-block;
            width: 26px;
            height: 44px;
            vertical-align: top;
            background: url("../../assets/images/document/excel.png") center no-repeat;
            background-size: contain;

        }
        .document-txt {
            display: inline-block;
            width: 26px;
            height: 44px;
            vertical-align: top;
            background: url("../../assets/images/document/txt.png") center no-repeat;
            background-size: contain;

        }
        .document-undefined {
            display: inline-block;
            width: 26px;
            height: 44px;
            vertical-align: top;
            background: url("../../assets/images/document/undefined.png") center no-repeat;
            background-size: contain;

        }
        .map-item-img {
            width: 26px;
            height: 28px;
            // vertical-align: middle;
            margin-bottom: 8px;

        }

        .map-item-name {
            margin-left: 10px;
            font-size: 14px;
            color: black;
            &:hover {
                color: #3b8cff;
            }
        }
    }

    /*
        子页面
    */

    .mapDetailPage {
        .container {
            background-color: #efefef;
            min-height: 100%;
            .doc {
                width: 100%;
                height: 751px;
            }
            .aplayer-control-bar{
                position: absolute;
                width: 100%;
                bottom: 0;
                right: 0;
                left: 0;
                .aplayer /deep/ {
                         .aplayer-controller .aplayer-time .aplayer-icon.inactive{
                             display: none;
                         }
                    }

            }
        }

    }

    .animated {
        -webkit-animation-duration: .3s;
        animation-duration: .3s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
    }
</style>




